const latinCharactersRegex = /[A-Za-z]/;
const greekCharactersRegex = /[\u0370-\u03FF\u1F00-\u1FFF]/;

const mixedLangMessage =
    'Διπλή γλώσσα συμπλήρωσης (ελληνικά & αγγλικά). Έλεγξε ξανά!';

export const singleAlphabet = (stringSchema) => {
    if (!stringSchema) {
        return stringSchema;
    }

    return stringSchema.test(
        'single-alphabet',
        mixedLangMessage,
        (value) => {
            if (typeof value !== 'string') {
                return true;
            }

            const containsGreek = greekCharactersRegex.test(value);
            const containsLatin = latinCharactersRegex.test(value);

            return !(containsGreek && containsLatin);
        }
    );
};

export const GREEK_NATIONALITY = 'Ελληνική';

export const hasLatinCharacters = (value) =>
    typeof value === 'string' && latinCharactersRegex.test(value);

export const isValidDate = (dayObj) => {
    const day = dayObj.day ? parseInt(dayObj.day, 10) : 1; // Default to 1 if day is not provided
    const month = parseInt(dayObj.month, 10) - 1; // months are 0-indexed in JavaScript Date
    const year = parseInt(dayObj.year, 10);

    if (isNaN(month) || isNaN(year) || year < 0 || month < 0 || month > 11 || day < 1 || day > 31) {
        return false;
    }

    const date = new Date(year, month, day);

    return !(date.getFullYear() !== year || date.getMonth() !== month || date.getDate() !== day);
}

export const isOfDrivingAge = (dayObj) => {
    const { day, month, year } = dayObj;

    // Create the Date object using separate parameters (month is zero-indexed)
    const birthDate = new Date(year, month - 1, day);
    const today = new Date();

    // Calculate age by subtracting birth year from current year
    let age = today.getFullYear() - birthDate.getFullYear();

    // Check if the birth month and day have occurred yet this year
    const birthMonth = birthDate.getMonth();
    const birthDay = birthDate.getDate();

    if (
        today.getMonth() < birthMonth ||
        (today.getMonth() === birthMonth && today.getDate() < birthDay)
    ) {
        age--;
    }

    // Check if the person is of driving age (>= 17 years and < 99 years)
    return age >= 17 && age < 99;
}

export const isValidLicenseIssueDate = (dayObj, licenseYears) => {
    if (!dayObj) {
        return false;
    }

    const yearString = `${dayObj.year ?? ''}`.trim();
    if (!/^\d{4}$/.test(yearString)) {
        return false;
    }

    if (!isValidDate(dayObj)) {
        return false;
    }

    const day = parseInt(dayObj.day, 10);
    const month = parseInt(dayObj.month, 10) - 1;
    const year = parseInt(dayObj.year, 10);

    const issueDate = new Date(year, month, day);
    issueDate.setHours(0, 0, 0, 0);

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const parsedLicenseYears = Number.parseInt(licenseYears, 10);
    if (Number.isNaN(parsedLicenseYears)) {
        return issueDate <= today;
    }

    const minYears = Math.max(0, parsedLicenseYears);
    const maxYears = minYears + 1;

    const minDate = new Date(today);
    minDate.setFullYear(today.getFullYear() - maxYears);

    const maxDate = new Date(today);
    maxDate.setFullYear(today.getFullYear() - minYears);

    return issueDate >= minDate && issueDate <= maxDate;
}

export default singleAlphabet;
